<template>    
    <b-form class="subscription-form">
        <div v-if="loading" class="d-flex justify-content-center mb-3">
            <b-spinner label="Envoi..."></b-spinner>
        </div>

        <div v-if="!form.submitted && !loading && !message.show">
            <b-form-group 
                id="fieldset-mailing-list"
                label="Restez à l'affut avec l'infolettre KLIX"
                label-for="mailing-list"
            >
                <b-form-input
                    id="mailing-list"
                    v-model="form.email"
                    placeholder="Entrez votre courriel"
                    size="sm"
                    trim
                    :formatter="emailFormatter"
                    :state="emailValidation"
                ></b-form-input>
            </b-form-group>

            <transition name="slide">
                <b-form-group
                    id="fieldset-mailing-frequency"
                    label="Fréquence souhaitée"
                    label-for="mailing-frequency"
                    v-if="emailValidation"
                >
                    <b-form-radio-group
                        id="mailing-frequency"
                        name="mailing-frequency"
                        class="w-100"
                        v-model="form.frequency"
                        :options="frequency.options"
                        size="sm"
                        stacked
                    ></b-form-radio-group>
                </b-form-group>
            </transition>

            
            <transition name="slide">
                <b-button 
                    @click="subscribe" 
                    class="p-3 btn-cta upper"
                    v-if="formValidation"
                    block
                    size="sm"
                >
                    <font-awesome-icon icon="check-circle" size="lg" class="mr-2"/>S'abonner
                </b-button>
            </transition>
        </div>

        <b-alert 
            dismissible
            @dismissed="alertDismissed"
            v-model="message.show"
            :variant="message.variant"
        >
            {{ message.text }}
        </b-alert>
    </b-form>
</template>

<script>
import axios from 'axios'

export default {
    name: 'SubscriptionForm',
    data() {
        return {
            loading: false,
            message: {
                text: null,
                show: false,
                variant: `success`
            },
            frequency: {
                disabled: true,
                options: [
                    {
                        value: 'w',
                        text: 'Hebdomadaire'
                    },
                    {
                        value: 'b',
                        text: 'Bi-hebdomadaire'
                    },
                    {
                        value: 'm',
                        text: 'Mensuelle'
                    },
                    {
                        value: 'q',
                        text: 'Trimestrielle'
                    }
                ]
            },
            form: {
                frequency: null,
                firstName: null,
                lastName: null,
                email: null,
                submitted: false
            }
        }
    },
    computed: {
        emailValidation() {
            let field = this.form.email
            let pattern =/^[\da-z\.-_]{2,150}@[\da-z\.-_]{2,150}\.([\da-z]{2,5})$/

            if (field !== null) {
                let test = pattern.test(field)

                if (test) this.frequency.disabled = false
                else this.frequency.disabled = true

                return test
            }
            
            this.frequency.disabled = true

            return null
        },
        selectValidation() {
            let field = this.form.frequency

            if (field && field !== null) {
                return true
            }

            return null
        },
        formValidation() {
            if (this.emailValidation === true && this.selectValidation) {
                return true
            }

            return false
        }
    },
    methods: {
        messageReset() {
            this.message = {
                text: ``,
                show: false,
                variant: `success`
            }
        },
        alertDismissed() {
            this.messageReset()
            if(this.form.submitted === true) {
                this.$emit('subscribed')
            }
        },
        emailFormatter(string) {
            return string.toLowerCase()
        },
        subscribe() {
            let data = {
                email: this.form.email,
                freq: this.form.frequency
            }
            this.loading = true
                
            axios.post('/api/subscribe', data)
                .then(response => {
                    this.message = {
                        text: `Votre courriel a été ajouté à notre liste d'envoi. Pas plus compliqué que ça!`,
                        show: true,
                        variant: `success`
                    }
                    this.loading = false
                    this.form.submitted = true
                })
                .catch(e => {
                    this.message = {
                        text: `Une difficulté s'est produite durant l'enregistrement. Veuillez réessayer plus tard.`,
                        show: true,
                        variant: `danger`
                    }
                    this.loading = false
                })


            return false
        }
    }
}
</script>

<style scoped>
.form-control {
    border: none !important;
}
</style>